<template>
  <div class="page-container">
    <!-- 轮播图 -->
    <el-carousel
      height="100vh"
      :indicator-position="carouselSlides.length > 1 ? 'bottom' : 'none'"
      :arrow="carouselSlides.length > 1 ? 'always' : 'never'"
      class="hero-carousel"
      v-if="carouselSlides.length"
    >
      <el-carousel-item v-for="(slide, index) in carouselSlides" :key="index">
        <div class="carousel-content">
          <img class="bg" :src="slide" />
        </div>
      </el-carousel-item>
    </el-carousel>
    <div
      class="main-container"
      :class="{ 'has-carousel': carouselSlides.length > 0 }"
    >
      <div v-html="con" ></div>
      
      <!-- 表单部分，仅在 Free-Trial 页面显示 -->
      <div v-if="route.params.id === 'Free-Trial'" class="form-module">
        <h2 class="form-title">免费试用申请</h2>
        <el-form
          ref="formRef"
          :model="form"
          :rules="rules"
          label-width="140px"
          class="free-trial-form"
        >
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="form.mobile" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="公司名称" prop="company">
          <el-input v-model="form.company" placeholder="请输入公司名称"></el-input>
        </el-form-item>
        <el-form-item label="职位" prop="position">
          <el-input v-model="form.position" placeholder="请输入职位"></el-input>
        </el-form-item>
        <el-form-item label="想要获取的信息" prop="info">
          <el-input
            v-model="form.info"
            type="textarea"
            placeholder="请输入想要获取的信息"
            :rows="3"
          ></el-input>
        </el-form-item>
        <el-form-item class="center-buttons">
          <el-button type="primary" @click="submitForm">提交</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useRoute, useHead } from '#app';
import { GetApi, PostApi } from '~/composables/http';
import { ElMessage } from 'element-plus';

const route = useRoute();
const carouselSlides = ref([]);
const con = ref("");
const keywords = ref(""); // 定义 keywords ref
const formRef = ref(null);

// 表单数据
const form = ref({
  name: '',
  email: '',
  mobile: '',
  company: '',
  position: '',
  info: ''
});

// 验证规则
const rules = ref({
  name: [
    { required: false, message: '请输入姓名', trigger: 'blur' }
  ],
  email: [
    { required: true, message: '请输入邮箱', trigger: 'blur' },
    { 
      type: 'email', 
      message: '请输入正确的邮箱格式', 
      trigger: 'blur' 
    }
  ],
  mobile: [
    { required: true, message: '请输入手机号', trigger: 'blur' },
    { 
      pattern: /^1[3-9]\d{9}$/, 
      message: '请输入正确的手机号格式', 
      trigger: 'blur' 
    }
  ],
  company: [
    { required: true, message: '请输入公司名称', trigger: 'blur' }
  ],
  position: [
    { required: false, message: '请输入职位', trigger: 'blur' }
  ],
  info: [
    { message: '请输入想要获取的信息', trigger: 'blur' }
  ]
});

function fetchData() {
  GetApi("api/html/getHtml", { html_name: route.params.id }).then((res) => {
    if (res.errcode == 0) {
      let data = res.data;
      con.value = data.html_data;
      carouselSlides.value = data.html_images || [];
      if (data.keywords) {
        keywords.value = data.keywords;
        // 设置页面 keywords 元信息
        useHead({
          meta: [{ name: "keywords", content: keywords.value }],
        });
      }
    }
  });
}
fetchData();

// 提交表单
const submitForm = () => {
  if (!formRef.value) return;
  
  formRef.value.validate((valid) => {
    if (valid) {
      // 使用指定的API接口提交表单数据
      PostApi('api/user/save', form.value, { showLoading: true })
        .then((res) => {
          if (res.errcode === 0) {
            ElMessage.success('表单提交成功');
            console.log('表单提交成功:', res);
            // 重置表单
            resetForm();
          } else {
            ElMessage.error(res.message || '表单提交失败');
          }
        })
        .catch((error) => {
          ElMessage.error('网络错误，请稍后重试');
          console.error('表单提交失败:', error);
        });
    } else {
      ElMessage.error('请检查表单填写是否正确');
      return false;
    }
  });
};

// 重置表单
const resetForm = () => {
  if (!formRef.value) return;
  formRef.value.resetFields();
};

watch(
  route.params.id,
  () => {
    if (route.params.id) {
      fetchData();
    }
  },
  { immediate: false }
);
</script>
<style lang="scss">

/* 表单项目样式 */
.form-module .free-trial-form .el-form-item {
  margin-bottom: 25px;
}
.form-module .free-trial-form .el-form-item__error {
  font-size: 14px !important;
  color: #e74c3c !important;
  padding-left: 15px !important;
}
/* 标签样式 */
.form-module .free-trial-form .el-form-item__label {
  font-size: 16px !important;
  font-weight: 500 !important;
  color: #333 !important;
  line-height: 64px !important;
}
.form-module .free-trial-form .el-input__wrapper {
 border:none !important;
 box-shadow: none !important;
}
/* 输入框样式 */
.form-module .free-trial-form .el-input__inner {
  padding: 6px 24px !important;
  border-radius: 12px !important;
  font-size: 14px !important;
  height: 52px !important;
  border: 2px solid #e1e8ed !important;
  transition: all 0.3s ease !important;
  background-color: #f9fafb !important;
}

/* 输入框聚焦样式 */
.form-module .free-trial-form .el-input__inner:focus {
  border-color: #3498db !important;
  box-shadow: 0 0 0 4px rgba(52, 152, 219, 0.1) !important;
  background-color: #ffffff !important;
}

/* 文本域样式 */
.form-module .free-trial-form .el-textarea__inner {
  padding: 20px 24px !important;
  border-radius: 12px !important;
  font-size: 16px !important;
  min-height: 140px !important;
  border: 2px solid #e1e8ed !important;
  transition: all 0.3s ease !important;
  background-color: #f9fafb !important;
  resize: vertical !important;
}

/* 文本域聚焦样式 */
.form-module .free-trial-form .el-textarea__inner:focus {
  border-color: #3498db !important;
  box-shadow: 0 0 0 4px rgba(52, 152, 219, 0.1) !important;
  background-color: #ffffff !important;
}

/* 按钮容器样式 */
.form-module .free-trial-form .el-form-item:last-child {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 0;
}

/* 按钮样式 */
.form-module .free-trial-form .el-button {
  font-size: 18px !important;
  padding: 20px 40px !important;
  border-radius: 12px !important;
  margin: 0 15px !important;
  font-weight: 600 !important;
  transition: all 0.3s ease !important;
}

/* 主要按钮样式 */
.form-module .free-trial-form .el-button--primary {
  background-color: #3498db !important;
  border-color: #3498db !important;
}

/* 主要按钮悬停样式 */
.form-module .free-trial-form .el-button--primary:hover {
  background-color: #2980b9 !important;
  border-color: #2980b9 !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 12px rgba(52, 152, 219, 0.3) !important;
}

/* 次要按钮样式 */
.form-module .free-trial-form .el-button:not(.el-button--primary) {
  border: 2px solid #e1e8ed !important;
}

/* 次要按钮悬停样式 */
.form-module .free-trial-form .el-button:not(.el-button--primary):hover {
  border-color: #3498db !important;
  color: #3498db !important;
  transform: translateY(-2px) !important;
}

</style>
<style lang="scss" scoped>
.main-container {
  &.has-carousel {
    margin-top: 30px;
  }
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

/* 表单模块样式 */
.form-module {
  margin: 40px 0;
  
  .form-title {
    text-align: center;
    font-size: 36px;
    font-weight: 700;
    margin-bottom: 40px;
    color: #2c3e50;
    letter-spacing: 1px;
  }
}

/* 表单样式 */
.form-module .free-trial-form {
  max-width: 900px;
  margin: 0 auto;
  padding: 50px;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.12);
  border: 1px solid #e8e8e8;
}

/* Hero Carousel Styles */
.hero-carousel {
  min-height: 0 !important;
  height: 100vh;
  width: 100%;
}
.page-container {
  margin-top: 70px;
}

.carousel-content {
  height: 100vh;
  background-size: cover;
  background-position: center;
  position: relative;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
 
  box-sizing: border-box;
  .bg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: -1;
  }
}
</style>
